import { StageTools } from '../types';

export const MVP_CREATION_TOOLS: StageTools = [
  {
    category: "开发工具",
    tools: [
      {
        name: "GitHub",
        icon: "",
        description: "代码托管和协作平台",
        url: "https://github.com",
        tags: ["代码托管", "版本控制"]
      },
      {
        name: "Vercel",
        icon: "",
        description: "前端项目部署平台",
        url: "https://vercel.com",
        tags: ["项目部署", "自动化部署"]
      }
    ]
  },
  {
    category: "测试工具",
    tools: [
      {
        name: "Postman",
        icon: "",
        description: "API测试工具",
        url: "https://www.postman.com",
        tags: ["API测试", "接口调试"]
      },
      {
        name: "Jest",
        icon: "",
        description: "JavaScript测试框架",
        url: "https://jestjs.io",
        tags: ["单元测试", "自动化测试"]
      }
    ]
  },
  {
    category: "项目管理",
    tools: [
      {
        name: "Trello",
        icon: "",
        description: "项目管理和任务跟踪工具",
        url: "https://trello.com",
        tags: ["项目管理", "任务跟踪"]
      },
      {
        name: "语雀",
        icon: "",
        description: "专业的云端知识库",
        url: "https://www.yuque.com",
        tags: ["文档管理", "团队协作"]
      }
    ]
  }
]; 